import { Component, OnInit } from '@angular/core';
import { AbstractControl, FormArray, FormBuilder, FormGroup } from '@angular/forms';
import { BehaviorSubject } from 'rxjs';
import { TableData } from './data-table';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-test',
  templateUrl: './test.component.html',
  styleUrls: ['./test.component.scss'],
  // encapsulation: ViewEncapsulation.None,
})
export class TestComponent implements OnInit {
  data: TableData[] = [{ from: '', to: '' }];
  dataSource = new BehaviorSubject<AbstractControl[]>([]);
  displayColumns = ['no', 'from', 'to', 'action'];
  rows: FormArray = this.fb.array([]);
  form: FormGroup = this.fb.group({ 'info': this.rows });
  formDate: FormGroup;

  constructor(
    private fb: FormBuilder,
    public dialog: MatDialog,
    ) { 
    this.form_date()
  }

  ngOnInit() {
    this.data.forEach((d: TableData) => this.addRow(d, false));
    this.updateView();
    this.formDate.get('date').disable()
  }

  emptyTable() {
    while (this.rows.length !== 0) {
      this.rows.removeAt(0);
    }
  }

  addRow(d?: TableData, noUpdate?: boolean) {
    const row = this.fb.group({
      'from': [d && d.from ? d.from : null, []],
      'to': [d && d.to ? d.to : null, []]
    });
    this.rows.push(row);
    if (!noUpdate) { this.updateView(); }
  }

  updateView() {
    this.dataSource.next(this.rows.controls);
  }

  deleteRow(index){
    var delBtn = confirm(" Do you want to delete ?");
    if ( delBtn == true ) {
      this.rows.removeAt(index);
      this.updateView();
    }   
  } 

  private form_date() {
    this.formDate = this.fb.group({
      date: [''],
    })
  }

  send_date(){
    const bDate: Date = new Date('4/8/2020');
    this.formDate.controls['date'].setValue(bDate)
    this.formDate.get('date').disable()
    console.log(this.formDate.value);
  }

  open_dialog(){
    // Dialog Delete
    const dialogRef = this.dialog.open(dialog_test, {
      width: '710px',
    });

    dialogRef.afterClosed().subscribe(result => {
      console.log('The dialog was closed');
    })

  }

}

@Component({
  selector: 'dialog_test',
  templateUrl: 'test_dialog.html',
  styleUrls: ['test.component.scss']
})
export class dialog_test implements OnInit {

  constructor(
    public dialogRef: MatDialogRef<dialog_test>,
  ) {
  }

  ngOnInit() {
  }

  onNoClick(): void {
    this.dialogRef.close();
  }
}
